import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=64421784&scoped=true&"
import script from "./announcement.vue?vue&type=script&lang=js&"
export * from "./announcement.vue?vue&type=script&lang=js&"
import style0 from "./announcement.vue?vue&type=style&index=0&id=64421784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64421784",
  null
  
)

export default component.exports